<template>
	<div class="checkbox" :class="[disabledInfo ? 'is-disabled-w-info' : '']">
		<input
			class="checkbox__input"
			type="checkbox"
			:name="`${uid}_checkbox`"
			:checked="shouldBeChecked"
			:disabled="disabled"
			:id="uid"
			:value="value"
			:variant="variant"
			@input="updateInput"
		/>
		<label class="checkbox__label" v-if="labelText" :for="uid">
			{{ labelText }}
		</label>
	</div>
</template>
<script>
export default {
	name: 'Checkbox',
	model: {
		prop: 'modelValue',
		event: 'input'
	},
	props: {
		labelText: {
			type: String,
			default: ''
		},
		value: {
			type: [String, Number, Boolean],
			default: true
		},
		modelValue: {
			type: [String, Number, Boolean],
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		disabledInfo: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		shouldBeChecked() {
			return this.modelValue === this.value;
		}
	},
	methods: {
		updateInput(e) {
			this.$emit('input', this.value, e.target.checked);
		}
	}
};
</script>
<style lang="scss">
/**
    * [Description]
    *
    * Global Checkbox
    * Can use SCSS variables = TRUE
    *
    * All checkbox styles and variations are included here.
    *
    * [Table of Contents]
    *
        * BASE
 */
/*------------------------------------*\
  #BASE
\*------------------------------------*/
@import '@/scss/5-objects/_form.scss';
.checkbox {
	@include create-check-element('.checkbox__input', 15px, 15px, 2px);
}
.checkbox__input {
	&:checked {
		&::after {
			@include vertical-horizontal-center-with-transform;
			font-family: 'vue-support-icons';
			font-size: 9px;
			height: 9px;
			color: $accent-text-dark;
			content: '\e92e';
		}
	}
	&:indeterminate,
	&[indeterminate] {
		// the attribute is only for testing purposes.
		background-color: $check-bkgd--indeterminate;
		&::after {
			@include vertical-horizontal-center-with-transform;
			font-family: 'vue-support-icons';
			font-size: 15px;
			color: $white;
			content: '\e92f';
		}
	}
}
</style>
